import { createSlice } from "@reduxjs/toolkit";
import { apiCaller } from "../../api/apiCaller";
import { playerapi } from "../../sharedfiles/EndpointConfig";
import { toaster } from "../../sharedfiles/helper";
export const AddNoteSlice = createSlice({
  name: "addNotesSlice",
  initialState: {
    paginationFirstValue: 1,
    paginationSecondValue: 25,
    userData: [],
    notesData: [],
    addnoteid: 0,
    recordsShow: [1, 25],
    isVisible: false,
  },
  reducers: {
    setNotes: (state, action) => {
      state.notesData = action.payload;
    },
    setAddNoteValue: (state, action) => {
      state.addnoteid = action.payload;
    },
    setPaginationFirstValue: (state, action) => {
      state.paginationFirstValue = action.payload;
    },
    setPaginationSecondValue: (state, action) => {
      state.paginationSecondValue = action.payload;
    },
    setRecordsShow: (state, action) => {
      state.recordsShow = action.payload;
    },
    setIsVisible: (state, action) => {
      state.isVisible = action.payload;
    },
  },
});
export const {
  setNotes,
  setAddNoteValue,
  setPaginationFirstValue,
  setPaginationSecondValue,
  setMessage,
  resetNotesData,
  setRecordsShow,
  setIsVisible,
} = AddNoteSlice.actions;

export const getAddNotestableList = (id, params) => (dispatch, getState) => {
  var obj = {
    category: params.category,
    note: params.note,
  };
  var url = `${playerapi.getAddNotes}` + id + "/note";
  const { addNotesSlice } = getState();
  console.log("I'm callig in adding notes to DB caller");
  apiCaller(url, "POST", obj)
    .then((response) => {
      // if (response !== null && response) {
      dispatch(getNotesList(addNotesSlice.paginationFirstValue - 1, addNotesSlice.paginationSecondValue))
      console.log("I'm callig in adding notes to DB caller at line -78");
      if (response.status == 200) {
        toaster.success("NOTE ADDED");
      }
      // }
    })
    .catch((error) => {
      console.log("error in  adding note: ", error);
      toaster.error("FAILED TO ADD NOTE");
    });
};

//dev.platform-ups.negroup-tech.net:443/player/notes?pageNumber=0&itemsPerPage=25
export const getNotesList = (pagenumbervalue, itemperpagevalue) => (dispatch) => {
  const id = localStorage.getItem("userId")
  var url =
    `${playerapi.getNotes}` +
    "?pageNumber=" +
    pagenumbervalue +
    "&itemsPerPage=" +
    itemperpagevalue;

  apiCaller(url, "POST", { playerId: id }).then((response) => {
    if (response !== null && response) {
      if (response.status == 200) {
        dispatch(setNotes(response.data));
      }
      dispatch(setIsVisible(true));
    }
  }).catch(() => { });
};

const fetchUpdatedNotes = (dispatch, addNotesSlice) => {
  const { paginationFirstValue, paginationSecondValue } = addNotesSlice;
  dispatch(getNotesList(paginationFirstValue - 1, paginationSecondValue));
};
// edit note
export const editNotes = (playerId, id, payload) => (dispatch, getState) => {
  const { addNotesSlice } = getState();
  const url = `${playerapi.editNotes}${playerId}/notes/${id}`;
  apiCaller(url, "PUT", payload)
    .then((response) => {
      if (response?.status === 200) {
        setTimeout(() => {
          fetchUpdatedNotes(dispatch, addNotesSlice);
        }, 1000)
        toaster.success("NOTE UPDATED");
      } else {
        toaster.error("FAILED TO UPDATE NOTE");
      }
    })
    .catch((error) => {
      console.log("Error in updating note:", error);
      toaster.error("FAILED TO UPDATE NOTE");
    });
};

// Delete Note
export const deleteNotes = (playerId, id) => (dispatch, getState) => {
  const { addNotesSlice } = getState();
  const url = `${playerapi.deleteNotes}${playerId}/notes/${id}`;

  apiCaller(url, "DELETE")
    .then((response) => {
      if (response?.status === 200) {
        fetchUpdatedNotes(dispatch, addNotesSlice);
        toaster.success("NOTE DELETED");
      } else {
        toaster.error("FAILED TO DELETE NOTE");
      }
    })
    .catch((error) => {
      console.log("Error in deleting note:", error);
      toaster.error("FAILED TO DELETE NOTE");
    });
};

export default AddNoteSlice.reducer;
